import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  prevent: boolean;
  showLoadingSpinner: boolean;
}

const initialState: StateInterface = {
  prevent: false,
  showLoadingSpinner: false
};

export const loadingReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {

  /*
  |  This is a bit hacky. If the request to backend ends with request, then we show the spinner.
  |  Otherwise, we hide the spinner. It makes us rely on consistent constant names.
  |  We'll create a wrapper about it in the future, but for now, this one works well. @todo
  */

  // Ignore all attachment actions since we handle them manually.
  if (action.type.includes("_ATTACHMENT_") === true) {
    return {
      ...state
    };
  }

  if (action.type.endsWith("_REQUEST") === true) {
    return {
      ...state,
      showLoadingSpinner: state.prevent === true ? state.showLoadingSpinner : true
    };
  }

  if (action.type.endsWith("_SUCCESS") === true) {
    return {
      ...state,
      showLoadingSpinner: state.prevent === true ? state.showLoadingSpinner : false
    };
  }

  if (action.type.endsWith("_FAILURE") === true) {
    return {
      ...state,
      showLoadingSpinner: state.prevent === true ? state.showLoadingSpinner : false
    };
  }

  if (action.type === Constants.LOADING_SHOW) {
    return {
      ...state,
      prevent: true,
      showLoadingSpinner: true
    };
  }

  if (action.type === Constants.LOADING_HIDE) {
    return {
      ...state,
      prevent: false,
      showLoadingSpinner: false
    };
  }

  if (action.type === Constants.AUTH_SIGNOUT) {
    return {
      ...initialState
    };
  }

  return {
    ...state
  };
};
